import { Button } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";

export const OptionButton = ({
  label,
  isActive,
  onClick,
}: {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}) => (
  <Button
    onClick={onClick}
    size="small"
    className={cx(
      "hover:border-primary-200 hover:bg-primary h-[40px] border-[1px] border-solid border-transparent font-normal",
      {
        "text-dark border-grey-400 hover:text-dark hover:bg-transparent":
          !isActive,
      }
    )}
    variant={isActive ? "contained" : "outlined"}
    color={isActive ? "primary" : "grey"}
  >
    {label}
  </Button>
);
